import { CdkPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Directive, OnInit } from '@angular/core';

import { FlyingFocus } from './flying-focus';
import { FlyingFocusComponent } from './flying-focus.component';

@Directive({
    selector: '[sbbFlyingFocus]',
    providers: [{ provide: FlyingFocus, useExisting: FlyingFocusDirective }],
    standalone: false
})
export class FlyingFocusDirective extends CdkPortalOutlet implements OnInit, FlyingFocus {
  ngOnInit() {
    super.ngOnInit();
    this.portal = new ComponentPortal(FlyingFocusComponent);
    let lastFocus: HTMLElement;
    (window as any).wcmsWebpackRuntimeConfig.customFlyingFocus.focus = (element: HTMLElement) => {
      if (
        element.classList.contains('mod_autocomplete_suggestion') ||
        (element.classList.contains('mod_textfield_control') &&
          lastFocus &&
          lastFocus.classList.contains('mod_autocomplete_suggestion'))
      ) {
        this.focus(element);
      }

      lastFocus = element;
    };
  }

  focus(element: Element) {
    if (this.attachedRef instanceof ComponentRef) {
      this.attachedRef.instance.focus(element);
    }
  }
}
